import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { GLOBAL_LOADING_Z_INDEX } from 'consts/zIndex'

const loadingAnimation = css`
  animation: dots-loading 1.5s infinite ease-in-out both;

  @keyframes dots-loading {
    0%,
    80%,
    100% {
      transform: scale(0.9);
      background: ${COLORS.secondaryLight};
    }
    40% {
      transform: scale(1);
      background: ${COLORS.primaryDark};
    }
  }
`

const pulseAnimation = css`
  animation: dots-pulse 1.5s infinite ease-in-out both;

  @keyframes dots-pulse {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`

interface IGetCurrentDotsAnimationProps {
  $animation: string
}

const getCurrentDotsAnimation = ({
  $animation
}: IGetCurrentDotsAnimationProps) => {
  if ($animation === 'pulse') {
    return pulseAnimation
  }
  return loadingAnimation
}

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: calc(var(--vh) * 100);
  position: absolute;
  top: 0;
  z-index: ${GLOBAL_LOADING_Z_INDEX - 1};
  background: rgba(255, 255, 255, 0.6);
`

interface IContainerProps {
  $withoutHeight: boolean | undefined
  $isTransparent: boolean
  $width: string | undefined
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  margin: auto;
  height: ${props => !props.$withoutHeight && '44px'};
  width: ${props => props.$width || '155px'};
  padding: 0 16px;
  box-sizing: border-box;
  z-index: ${GLOBAL_LOADING_Z_INDEX};

  ${({ $isTransparent }) => {
    if ($isTransparent) {
      return css`
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        opacity: 0.8;
      `
    }
    return ''
  }}
`

export const DotsLoadingWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

interface IDotProps {
  $dotSize: number
  $dotColor: string | undefined
  $animation: string
}

export const Dot = styled.div<IDotProps>`
  margin: 6px;
  width: ${props => props.$dotSize}px;
  height: ${props => props.$dotSize}px;
  background-color: ${props =>
    props.$dotColor ? props.$dotColor : COLORS.white};
  border-radius: 100%;
  display: inline-block;
  ${({ $animation }) => getCurrentDotsAnimation({ $animation })}
  &.dot-1 {
    animation-delay: -0.5s;
  }
  &.dot-2 {
    animation-delay: -0.25s;
  }
  &.dot-3 {
    animation-delay: 0s;
  }
`
